<template>
  <div class="container-custom">
    <div class="head-custom">
      <div class="avatar-group-member">
        <!--        <span class="firstname-charset two-avatar-group" v-bind:key="avatar" v-for="avatar in avatars">{{ avatar }}</span>-->
        <span class="firstname-charset two-avatar-group cursor-pointer avatar-group"
        v-popover:tooltip.top="'Click để thay đổi'"
        @click="changeAvatar"
        v-if="this.$store.state.chat.chatGroupSelected.type === 'GROUP'"
        >
          <image-template
            class="avatar-group-member__image"
            :width="'120px'"
            :height="'120px'"
            :size="'small'"
            :image="avatars"
            :thumbnail="$store.state.chat.chatGroupSelected.thumbnail"
            :name="$store.state.chat.chatGroupSelected.name"
            img-type="group"
            shape="circle"
          />
          <md-icon class="icon-camera">photo_camera</md-icon>
        </span>

        <span class="firstname-charset two-avatar-group cursor-pointer avatar-group"
          v-if="this.$store.state.chat.chatGroupSelected.type === 'USER'"
          @click="goToProfile"
        >
          <image-template
            class="avatar-group-member__image"
            :width="'120px'"
            :height="'120px'"
            :size="'small'"
            :image="avatars"
            :thumbnail="$store.state.chat.chatGroupSelected.thumbnail"
            :name="$store.state.chat.chatGroupSelected.display_name || $store.state.chat.chatGroupSelected.name"
            shape="circle"
          />
        </span>

        <input type="file" ref="fileupload" accept="image/jpg, image/png, image/jpeg" hidden id="update-avatar-btn"
               @change="uploadFile">
      </div>
      <div class="name-group">
        <div class="name" :class="{ 'cursor-pointer': !isOfficialTeamGroupChat }" @click="handleGroupName()" v-if="!handleName">
          <span class="heading-500 name-group-name-row">
            {{ this.$store.state.chat.chatGroupSelected.name }}
            <md-icon
              v-if="showOfficialTeamVerifiedChat"
              class="official-team-verified md-icon md-icon-font md-theme-default"
              title="Nhóm chat chính thức theo đội (đã liên kết hệ thống)"
            >verified</md-icon>
            <md-icon
              v-else-if="showLeadershipDmVerified"
              class="chat-leadership-badge md-icon md-icon-font md-theme-default"
              :title="CHAT_LEADERSHIP_BADGE_TITLE"
            >{{ CHAT_LEADERSHIP_BADGE_ICON }}</md-icon>
          </span>
        </div>
        <div class="px-15px" v-if="handleName">
          <input type="text" class="change-group-name text-center" v-model="updateGroupName.name" />
          <div class="handle-button-group-name text-right">
            <span class="button-change-name cancel-changr-group-name cursor-pointer" @click="handleGroupName()">
              Hủy
            </span>
            <span class="button-change-name apply-changr-group-name cursor-pointer" @click="applyChangeGroupName()">
              Lưu
            </span>
          </div>
        </div>
      </div>
      <div class="custom-action-row">
        <button
          type="button"
          class="custom-action-row__item"
          :class="{ 'custom-action-row__item--disabled': isBotChatGroup }"
          :disabled="isBotChatGroup"
          :title="isBotChatGroup ? 'Không thể tắt thông báo nhóm BOT' : ''"
          @click="toggleNotificationFromButton"
        >
          <md-icon class="custom-action-row__icon" :class="{ 'custom-action-row__icon--active': notificationIsActive }">
            {{ notificationIsActive ? 'notifications_active' : 'notifications_off' }}
          </md-icon>
          <div class="custom-action-row__text">Thông báo</div>
        </button>

        <button type="button" class="custom-action-row__item" @click="toggleConversationPin">
          <md-icon class="custom-action-row__icon" :class="{ 'custom-action-row__icon--active': conversationPinned }">
            push_pin
          </md-icon>
          <div class="custom-action-row__text">{{ conversationPinned ? 'Bỏ ghim' : 'Ghim' }}</div>
        </button>

        <button
          v-if="isGroup && canAddMember"
          type="button"
          class="custom-action-row__item"
          @click="openAddMember"
        >
          <md-icon class="custom-action-row__icon">person_add</md-icon>
          <div class="custom-action-row__text">Thêm TV</div>
        </button>
      </div>
    </div>
    <div v-if="showChatAnnouncementPreview" class="custom-media-preview custom-announcements-preview">
      <div class="custom-media-preview__header">
        <div class="custom-media-preview__title">Thông báo</div>
        <button type="button" class="custom-media-preview__view-all" @click="$emit('open-announcements-panel')">
          Xem tất cả
        </button>
      </div>
      <ChatAnnouncementsFeed
        mode="group"
        :limit="2"
        :only-active="true"
        :show-group-name="false"
        empty-text="Không có thông báo đang hiệu lực"
      />
    </div>
    <div class="custom-media-preview">
      <div class="custom-media-preview__header">
        <div class="custom-media-preview__title">Media</div>
        <button type="button" class="custom-media-preview__view-all" @click="openLibrary">
          Xem tất cả
        </button>
      </div>

      <div v-if="mediaLoading && mediaItems.length === 0" class="custom-media-preview__loading">Đang tải...</div>
      <div v-else-if="mediaItems.length === 0" class="custom-media-preview__empty">Không có dữ liệu</div>
      <div
        v-else
        class="custom-media-preview__grid"
        :class="{ 'custom-media-preview__grid--refreshing': mediaPreviewRefreshing }"
      >
        <button
          v-for="(item, mediaIdx) in mediaItemsPreview"
          :key="mediaPreviewCellKey(item, mediaIdx)"
          type="button"
          class="custom-media-preview__cell"
          @click="showMediaSlideShow(item)"
        >
          <!-- Dùng ảnh poster thay vì <video>: trình như Cốc Cốc hay chèn thanh tải lên video và làm vỡ layout khi hover -->
          <template v-if="isMediaPreviewVideo(item)">
            <img
              v-if="getMediaThumb(item)"
              class="custom-media-preview__thumb custom-media-preview__thumb--video"
              :src="getMediaThumb(item)"
              alt=""
              loading="lazy"
              decoding="async"
            >
            <div
              v-else
              class="custom-media-preview__thumb custom-media-preview__thumb--video custom-media-preview__thumb--video-fallback"
              aria-hidden="true"
            />
            <span class="custom-media-preview__video-overlay">
              <span class="material-icons custom-media-preview__video-icon">play_arrow</span>
            </span>
          </template>
          <template v-else>
            <img
              class="custom-media-preview__thumb"
              :src="getMediaThumb(item)"
              alt="media"
              loading="lazy"
              decoding="async"
            >
          </template>
        </button>
      </div>
    </div>
    <div v-if="isGroup" class="custom-media-preview custom-rule-block">
      <div class="custom-media-preview__header">
        <div class="custom-media-preview__title">Nội quy</div>
        <div class="custom-rule-block__actions">
          <button
            v-if="hasRuleContent"
            type="button"
            class="custom-rule-block__icon-btn md-button-clean"
            aria-label="Xem đầy đủ nội quy"
            @click="$modal.show('rule-full-modal')"
          >
            <md-icon>open_in_full</md-icon>
          </button>
          <button
            v-if="ruleIsAdmin"
            type="button"
            class="custom-rule-block__icon-btn md-button-clean"
            :aria-label="hasRuleContent ? 'Chỉnh sửa nội quy' : 'Thêm nội quy'"
            @click="$modal.show('update-rule-group')"
          >
            <md-icon>{{ hasRuleContent ? 'edit' : 'add' }}</md-icon>
          </button>
        </div>
      </div>
      <div
        v-if="ruleContent"
        class="post-layout custom-rule-block__body-shell mt-15px custom-rule-block__preview"
      >
        <div
          ref="ruleContentPreview"
          class="text-html custom-rule-block__text-html custom-rule-block__text-html--clamped"
          v-html="ruleContent"
        ></div>
        <button
          v-if="ruleContentOverflow"
          type="button"
          class="custom-rule-block__see-more"
          @click="openRuleFullModal"
        >
          Xem thêm
        </button>
      </div>
      <div class="custom-media-preview__empty" v-else>
        Chưa có nội quy
      </div>
      <update-rule-group @update-rule="updateGroup"></update-rule-group>
      <modal
        name="rule-full-modal"
        :click-to-close="true"
        width="640px"
        height="auto"
        class="modal-custom custom-rule-full-modal"
        transition="easeInOut"
      >
        <md-card class="modal-header-custom">
          <md-dialog-title>
            <span class="heading-500 text-header-modal">Nội quy</span>
            <span
              class="material-icons float-right cursor-pointer"
              @click="$modal.hide('rule-full-modal')"
            >close</span>
          </md-dialog-title>
        </md-card>
        <md-card-content class="custom-rule-full-modal__scroll">
          <div class="post-layout custom-rule-block__body-shell">
            <div class="text-html" v-html="ruleContent"></div>
          </div>
        </md-card-content>
        <md-dialog-actions class="p-15px w_100">
          <button
            type="button"
            class="btn-stroke md-button heading-300"
            @click="$modal.hide('rule-full-modal')"
          >
            Đóng
          </button>
        </md-dialog-actions>
      </modal>
    </div>
    <div class="info-thread__setting">
      <div class="thread-settings">
        <div class="collapse" v-if="isGroup" style="">
          <div class="setting-item setting-item--share-link">
            <div class="setting-item__icon">
              <svg width="20px" height="20px" fill="var(--spectrum-global-color-contentPrimary)"
                   xmlns="http://www.w3.org/2000/svg" class="app-icon" role="img" viewBox="0 0 24 24">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M20.308 3.692a5.75 5.75 0 0 0-8.131 0l-2.122 2.121a.75.75 0 0 0 1.061 1.06l2.121-2.12a4.25 4.25 0 1 1 6.01 6.01l-2.12 2.121a.75.75 0 0 0 1.06 1.06l2.121-2.12a5.75 5.75 0 0 0 0-8.132ZM3.691 20.308a5.75 5.75 0 0 1 0-8.132l2.122-2.121a.75.75 0 0 1 1.06 1.06l-2.12 2.122a4.25 4.25 0 0 0 6.01 6.01l2.12-2.12a.75.75 0 0 1 1.062 1.06l-2.122 2.121a5.75 5.75 0 0 1-8.132 0Zm3.536-4.596a.75.75 0 0 0 1.06 1.06l8.486-8.485a.75.75 0 0 0-1.06-1.06l-8.486 8.485Z"
                      fill="#26282C"></path>
              </svg>
            </div>
            <div class="setting-item__content">
              <div class="setting-item__content__title">Chia sẻ link nhóm</div>
              <span class="setting-item__content__subtitle">{{ groupShareLink }}</span>
            </div>
            <div class="setting-item__action cursor-pointer group-link-copy-wrap">
              <transition name="group-link-copied-fade">
                <span
                  v-if="showGroupLinkCopied"
                  class="group-link-copied-tip"
                  role="status"
                  aria-live="polite"
                >Đã copy</span>
              </transition>
              <img
                class="ml-15px group-link-copy-btn"
                src="/img/coppy-link.svg"
                alt="Sao chép link nhóm"
                title="Sao chép link"
                @click.stop="copyGroupShareLink"
              >
            </div>
          </div>

          <div class="setting-item select" v-if="isAdmin">
            <div class="setting-item__icon">
              <md-icon>schedule</md-icon>
            </div>
            <div class="setting-item__content" style="align-items: flex-start">
              <div class="setting-item__content__title">Giữ tin nhắn trong</div>
              <select
                class="select-box-role w_100 text-400-medium"
                v-model="messageRetentionDays"
                @change="updateRetentionSetting"
              >
                <option v-for="opt in retentionOptions" :key="opt" :value="opt">
                  {{ opt }} ngày
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="collapse" v-if="isUserChat">
          <div class="setting-item">
            <div class="setting-item__icon">
              <md-icon>schedule</md-icon>
            </div>
            <div class="setting-item__content" style="align-items: flex-start">
              <div class="setting-item__content__title">Giữ tin nhắn trong</div>
              <div class="retention-readonly-value text-400-medium neutral_2">30 ngày</div>
            </div>
          </div>
        </div>

        <div class="setting-item select" v-if="isAdmin">
          <div class="setting-item__icon">
            <svg width="20px" height="20px" fill="var(--spectrum-global-color-contentPrimary)" xmlns="http://www.w3.org/2000/svg" class="gapo-Icon" role="img" viewBox="0 0 24 24"><path d="M14 14a2 2 0 0 1-1 1.732V18a1 1 0 1 1-2 0v-2.268A2 2 0 0 1 12 12a2 2 0 0 1 2 2Z" fill="#18202A"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M22 12a4 4 0 0 0-4-4V7A6 6 0 0 0 6 7v1a4 4 0 0 0-4 4v7a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-7ZM12 2.5A4.5 4.5 0 0 1 16.5 7v1h-9V7A4.5 4.5 0 0 1 12 2.5ZM3.5 12A2.5 2.5 0 0 1 6 9.5h12a2.5 2.5 0 0 1 2.5 2.5v7a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 19v-7Z" fill="#18202A"></path></svg>
          </div>
          <div class="setting-item__content" style="align-items: flex-start">
            <div class="setting-item__content__title">Quyền thêm thành viên</div>
            <select class="select-box-role w_100 text-400-medium" v-model="join_policy" @change="updateRoleMember">
              <option class="text-400-medium" :selected="join_policy != 2" value="1">
                Chỉ quản trị viên
              </option>
              <option class="text-400-medium" :selected="join_policy == 2" value="2">
                Tất cả mọi người
              </option>
            </select>
          </div>
        </div>

        <div class="setting-item select" v-if="isAdmin">
          <div class="setting-item__icon">
            <md-icon>campaign</md-icon>
          </div>
          <div class="setting-item__content" style="align-items: flex-start">
            <div class="setting-item__content__title">Ai được gửi thông báo nhóm</div>
            <select class="select-box-role w_100 text-400-medium" v-model="announcement_policy" @change="updateAnnouncementPolicySetting">
              <option class="text-400-medium" value="1">
                Chỉ quản trị viên
              </option>
              <option class="text-400-medium" value="2">
                Tất cả mọi người
              </option>
            </select>
          </div>
        </div>

        <div
          class="group-danger-actions"
          v-if="isGroup && !isOfficialTeamGroupChat"
        >
          <button
            id="setting-item__leave-group"
            type="button"
            class="group-danger-actions__btn"
            @click="leaveGroupChat"
          >
            Rời khỏi nhóm
          </button>
          <button
            v-if="isAdmin"
            id="setting-item__dissolve-group"
            type="button"
            class="group-danger-actions__btn group-danger-actions__btn--dissolve"
            @click="dissolveGroupChat"
          >
            <span class="group-danger-actions__label">Giải tán nhóm</span>
            <span class="group-danger-actions__hint">Xóa cuộc trò chuyện với tất cả thành viên</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import ChatService from "../../../../../store/services/ChatService";
import PostService from "../../../../../store/services/PostService";
import { NOTIFICATION_CHAT, TYPE_ADD_GROUP_MEMBER } from "../../../../../const/const";
import GroupService from "../../../../../store/services/GroupService";
import UpdateRuleGroup from "../../../../Components/Modal/UpdateRuleGroup";
import ChatAnnouncementsFeed from "./ChatAnnouncementsFeed.vue";
import ImageTemplate from "../../../../../components/ImageTemplate";
import { isOfficialTeamGroup } from "../../../../../helper/officialTeamGroup";
import {
  CHAT_LEADERSHIP_BADGE_ICON,
  CHAT_LEADERSHIP_BADGE_TITLE,
  isChatLeadershipDmPeer,
} from "../../../../../helper/chatLeadershipBadge";
import { canCreateBotAnnouncementInBotChat } from "../../../../../helper/botChatOperator";
import { canAddChatMember, withJoinPolicy } from "../../../../../helper/chatGroupStore";

/** API getFileChatGroup không có `type`; nhận diện video qua extension (vd. mp4). */
const MEDIA_VIDEO_EXTENSIONS = new Set([
  'mp4', 'webm', 'ogg', 'ogv', 'mov', 'm4v', 'mpeg', 'mpg', 'avi', 'mkv', '3gp', '3gpp',
]);

export default {
  name: "Custom",
  components: {
    UpdateRuleGroup,
    ChatAnnouncementsFeed,
    ImageTemplate,
  },
  props: {},
  watch: {
    '$store.state.chat.chatGroupSelected': function () {
      this.syncRightbarDataFromConversation();
    },
    '$store.state.chat.chatGroupSelected.id': {
      handler(newId, oldId) {
        if (String(newId ?? '') === String(oldId ?? '')) return;
        this.scheduleFetchMediaPreview();
      },
      immediate: true,
    },
    '$route.params.messenger_id': {
      handler(newId, oldId) {
        this.syncRightbarDataFromConversation();
        if (String(newId ?? '') === String(oldId ?? '')) return;
        this.scheduleFetchMediaPreview();
      },
      immediate: true,
    },
    ruleContent() {
      this.scheduleMeasureRuleOverflow();
    },
  },
  mounted() {
    this.syncRightbarDataFromConversation();
    this.$root.$on('chat-group-media-appended', this.onChatGroupMediaAppended);
    this.scheduleMeasureRuleOverflow();
  },
  beforeDestroy() {
    this.$root.$off('chat-group-media-appended', this.onChatGroupMediaAppended);
    if (this.mediaPreviewDebounceTimer) {
      clearTimeout(this.mediaPreviewDebounceTimer);
      this.mediaPreviewDebounceTimer = null;
    }
    if (this.ruleOverflowMeasureTimer) {
      clearTimeout(this.ruleOverflowMeasureTimer);
      this.ruleOverflowMeasureTimer = null;
    }
    this.hideGroupLinkCopiedTip();
  },
  computed: {
    mediaItemsPreview() {
      return Array.isArray(this.mediaItems) ? this.mediaItems.slice(0, 8) : [];
    },
    hasRuleContent() {
      const raw = this.ruleContent;
      if (!raw || !String(raw).trim()) return false;
      const text = String(raw)
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      return text.length > 0;
    },
    showChatAnnouncementPreview() {
      const t = (this.$store.state.chat.chatGroupSelected || {}).type;
      return t && t !== 'USER' && t !== 'BOT';
    },
    isOfficialTeamGroupChat() {
      const g = this.$store.state.chat.chatGroupSelected || {};
      return g.type === 'GROUP' && isOfficialTeamGroup(g);
    },
    showOfficialTeamVerifiedChat() {
      return this.isOfficialTeamGroupChat;
    },
    showLeadershipDmVerified() {
      return isChatLeadershipDmPeer(this.$store.state.chat.chatGroupSelected);
    },
    /** Hội thoại 1-1: retention cố định 30 ngày (readonly). */
    isUserChat() {
      return (this.$store.state.chat.chatGroupSelected || {}).type === 'USER';
    },
    isBotChatGroup() {
      return (this.$store.state.chat.chatGroupSelected || {}).type === 'BOT';
    },
    showBotCreateAnnouncementAction() {
      const userId = this.$store.state.auth && this.$store.state.auth.user
        ? this.$store.state.auth.user.id
        : null;
      return canCreateBotAnnouncementInBotChat(
        this.$store.state.chat.chatGroupSelected,
        userId,
      );
    },
    groupShareLink() {
      const groupId = this.$route.params.messenger_id
        || (this.$store.state.chat.chatGroupSelected && this.$store.state.chat.chatGroupSelected.id);
      if (!groupId) return '';
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      return `${origin}/messenger/${groupId}`;
    },
    canAddMember() {
      return canAddChatMember(
        this.$store.state.chat.chatGroupSelected,
        this.$store.getters.user,
      );
    },
    isLastGroupAdmin() {
      const g = this.$store.state.chat.chatGroupSelected || {};
      const count = Number(g.active_admin_count);
      const adminCount = Number.isFinite(count) ? count : (Number(g.is_admin) === 1 ? 1 : 0);
      return Number(g.is_admin) === 1 && adminCount === 1;
    },
  },
  data(){
    return {
      CHAT_LEADERSHIP_BADGE_ICON,
      CHAT_LEADERSHIP_BADGE_TITLE,
      avatars : '', //['S', 'T'],
      notificationIsActive: false,
      conversationPinned: false,
      ruleContent: '',
      /** Nội dung dài hơn 10 dòng — hiện "Xem thêm" và mở modal full. */
      ruleContentOverflow: false,
      ruleOverflowMeasureTimer: null,
      ruleIsAdmin: false,
      ruleIsSaving: false,
      group_name_input: this.$store.state.chat.chatGroupSelected.name,
      handleName : false,
      showGroupLinkCopied: false,
      groupLinkCopyHideTimer: null,
      updateGroupName : {
        group_id : '',
        name : ''
      },
      isGroup : this.$store.state.chat.chatGroupSelected.type === 'GROUP',
      join_policy: 1,
      announcement_policy: '1',
      /** Auto-delete tin nhắn — chỉ chấp nhận 5 giá trị này, default 30 ngày. */
      retentionOptions: [1, 7, 15, 30, 45],
      messageRetentionDays: 30,
      retentionSaving: false,
      isAdmin: this.$store.state.chat.chatGroupSelected.is_admin === 1,
      mediaLoading: false,
      /** Giữ lưới khi đổi hội thoại — chỉ làm mờ, tránh unmount ảnh gây nháy. */
      mediaPreviewRefreshing: false,
      mediaItems: [],
      mediaPreviewFetchSeq: 0,
      mediaPreviewDebounceTimer: null,
      /** Tránh 2 request getFileChatGroup chồng lên nhau khi mở hội thoại. */
      mediaPreviewHttpBusy: false,
      mediaPreviewHttpRetry: false,
    }
  },
  methods: {
    openRuleFullModal() {
      this.$modal.show('rule-full-modal');
    },
    scheduleMeasureRuleOverflow() {
      if (this.ruleOverflowMeasureTimer) {
        clearTimeout(this.ruleOverflowMeasureTimer);
      }
      this.ruleOverflowMeasureTimer = setTimeout(() => {
        this.ruleOverflowMeasureTimer = null;
        this.measureRuleContentOverflow();
      }, 80);
    },
    measureRuleContentOverflow() {
      if (!this.hasRuleContent) {
        this.ruleContentOverflow = false;
        return;
      }
      this.$nextTick(() => {
        const el = this.$refs.ruleContentPreview;
        if (!el) {
          this.ruleContentOverflow = false;
          return;
        }
        this.ruleContentOverflow = el.scrollHeight > el.clientHeight + 1;
      });
    },
    scheduleFetchMediaPreview() {
      if (this.mediaPreviewDebounceTimer) {
        clearTimeout(this.mediaPreviewDebounceTimer);
      }
      this.mediaPreviewDebounceTimer = setTimeout(() => {
        this.mediaPreviewDebounceTimer = null;
        this.fetchMediaPreview();
      }, 120);
    },
    mediaPreviewCellKey(item, index) {
      const gid = String(this.$route.params.messenger_id || '');
      const mid = item?.media_file?.id ?? item?.id;
      if (mid != null) return `m-${gid}-${mid}`;
      return `m-${gid}-i${index}-${item?.created_at || ''}`;
    },
    openLibrary() {
      this.$emit('open-library');
    },
    async fetchMediaPreview() {
      const groupId = this.$route.params.messenger_id;
      if (!groupId) return;

      if (this.mediaPreviewHttpBusy) {
        this.mediaPreviewHttpRetry = true;
        return;
      }
      this.mediaPreviewHttpBusy = true;
      this.mediaPreviewHttpRetry = false;

      const seq = ++this.mediaPreviewFetchSeq;
      const hadGrid = this.mediaItems.length > 0;
      if (hadGrid) {
        this.mediaPreviewRefreshing = true;
      } else {
        this.mediaLoading = true;
      }

      try {
        const res = await GroupService.getFileChatGroup({
          page: 1,
          per_page: 8,
          group_id: groupId,
          type: 'IMAGE,VIDEO',
          order_by: 'created_at',
          order: 'desc',
        });
        if (seq !== this.mediaPreviewFetchSeq) return;
        if (String(groupId) !== String(this.$route.params.messenger_id)) return;
        this.mediaItems = Array.isArray(res?.data) ? res.data : [];
      } catch (e) {
        if (seq !== this.mediaPreviewFetchSeq) return;
        if (String(groupId) !== String(this.$route.params.messenger_id)) return;
        this.mediaItems = [];
      } finally {
        if (seq === this.mediaPreviewFetchSeq) {
          this.mediaLoading = false;
          this.mediaPreviewRefreshing = false;
        }
        this.mediaPreviewHttpBusy = false;
        if (this.mediaPreviewHttpRetry) {
          this.mediaPreviewHttpRetry = false;
          this.$nextTick(() => this.scheduleFetchMediaPreview());
        }
      }
    },

    onChatGroupMediaAppended({ groupId, items }) {
      if (!items || !items.length) return;
      if (String(groupId) !== String(this.$route.params.messenger_id)) return;

      const seenMedia = new Set();
      this.mediaItems.forEach((i) => {
        const mid = i.media_file && i.media_file.id;
        if (mid != null) seenMedia.add(mid);
        if (i.id != null) seenMedia.add(i.id);
      });

      const fresh = [];
      for (const it of items) {
        const mid = it.media_file && it.media_file.id;
        if (mid != null && seenMedia.has(mid)) continue;
        if (it.id != null && seenMedia.has(it.id)) continue;
        if (mid != null) seenMedia.add(mid);
        if (it.id != null) seenMedia.add(it.id);
        fresh.push(it);
      }
      if (!fresh.length) return;

      this.mediaItems = [...fresh, ...this.mediaItems].slice(0, 8);
    },
    getMediaThumb(item) {
      const mf = item?.media_file;
      return (
        mf?.thumbnail?.medium_thumb
        || mf?.thumbnail?.small_thumb
        || mf?.thumbnail?.thumb
        || mf?.thumbnail?.url
        || mf?.url
        || mf?.path
        || ''
      );
    },

    mediaFileExtension(mf) {
      if (!mf || typeof mf !== 'object') return '';
      let ext = String(mf.extension || '').replace(/^\./, '').toLowerCase();
      if (ext) return ext;
      const name = mf.name || '';
      const m = name.match(/\.([a-z0-9]+)$/i);
      if (m) return m[1].toLowerCase();
      const path = mf.path || mf.url || '';
      const m2 = String(path).match(/\.([a-z0-9]+)(?:\?|#|$)/i);
      return m2 ? m2[1].toLowerCase() : '';
    },

    isMediaPreviewVideo(item) {
      if (!item) return false;
      if ((item.type || '').toUpperCase() === 'VIDEO') return true;
      const ext = this.mediaFileExtension(item.media_file);
      return ext !== '' && MEDIA_VIDEO_EXTENSIONS.has(ext);
    },

    /** Mở slide-show-modal giống Thư viện (Library.vue → showFileSlideShow). */
    showMediaSlideShow(clickedItem) {
      if (this.isMediaPreviewVideo(clickedItem)) {
        this.$modal.show('slide-show-modal', {
          items: clickedItem,
          activeId: 0,
          isVideo: true,
          isLibrary: true,
        });
        return;
      }

      const imageOnly = this.mediaItemsPreview.filter((i) => !this.isMediaPreviewVideo(i));

      let activeId = imageOnly.findIndex(
        (i) =>
          i === clickedItem
          || (i.id != null && clickedItem.id != null && i.id === clickedItem.id)
          || (i.media_file?.id != null
            && clickedItem.media_file?.id != null
            && i.media_file.id === clickedItem.media_file.id)
      );

      if (activeId < 0) activeId = 0;

      this.$modal.show('slide-show-modal', {
        items: imageOnly.length ? imageOnly : [clickedItem],
        activeId,
        isVideo: false,
        isLibrary: true,
      });
    },
    syncRightbarDataFromConversation() {
      const selected = this.$store.state.chat.chatGroupSelected || {};
      this.updateGroupName.group_id = this.$route.params.messenger_id;
      this.updateGroupName.name = selected.name || '';
      this.avatars = selected.avatar || selected.avatar_url || null;
      this.notificationIsActive = selected.type === 'BOT' ? true : (selected.noty == NOTIFICATION_CHAT.ON);
      this.conversationPinned = !!(selected?.pin_at || selected?.pinAt || selected?.pinned_at);
      this.ruleContent = selected.description || '';
      this.ruleIsAdmin = selected.is_admin === 1;
      const joinPolicy = Number(selected.settings?.join_policy ?? 1);
      this.join_policy = joinPolicy === 2 ? 2 : 1;
      this.announcement_policy = String(selected.settings?.announcement_policy ?? 1);
      if (selected.type === 'USER') {
        this.messageRetentionDays = 30;
      } else {
        const retention = Number(selected.settings?.message_retention_days);
        this.messageRetentionDays = this.retentionOptions.includes(retention) ? retention : 30;
      }
      const providedOpts = Array.isArray(selected.settings?.retention_options)
        ? selected.settings.retention_options.map((v) => Number(v)).filter((v) => Number.isFinite(v))
        : [];
      if (providedOpts.length > 0) {
        this.retentionOptions = providedOpts;
      }
      this.isGroup = selected.type === 'GROUP';
      this.isAdmin = selected.is_admin === 1;
      this.scheduleMeasureRuleOverflow();
    },
    async updateGroup(rule_content){
      if (this.ruleIsSaving) return;

      const selected = this.$store.state.chat.chatGroupSelected || {};
      const socialGroupId = selected.social_group_id;
      const chatGroupId = selected.id;

      this.ruleIsSaving = true;
      try {
        const res = socialGroupId
          ? await GroupService.updateGroupRules(socialGroupId, { content: rule_content })
          : await GroupService.updateChatGroupRules(chatGroupId, { content: rule_content });
        if (!res || !res.status) {
          this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra!');
          return;
        }

        await this.$store.dispatch("chat/getChatGroups");
        const currentId = String(this.$route.params.messenger_id);
        const refreshed = (this.$store.state.chat.chatGroups || []).find((g) => String(g.id) === currentId);
        if (refreshed) {
          this.$store.commit('chat/updateChatGroupSelected', refreshed);
          this.ruleContent = refreshed.description || '';
        } else {
          this.ruleContent = rule_content;
        }

        this.$modal.hide('update-rule-group');
        this.$store.dispatch("alerts/success", 'Cập nhật nội quy thành công');
      } finally {
        this.ruleIsSaving = false;
      }
    },
    toggleNotificationFromButton() {
      if (this.$store.state.chat.chatGroupSelected.type === 'BOT') {
        this.notificationIsActive = true;
        return;
      }
      this.notificationIsActive = !this.notificationIsActive;
      this.notificationChange();
    },
    async toggleConversationPin() {
      const groupId = this.$route.params.messenger_id;
      if (!groupId) return;

      const next = !this.conversationPinned;
      const prev = this.conversationPinned;
      this.conversationPinned = next;
      try {
        const res = await ChatService.pinChatGroup({
          group_id: groupId,
          type: next ? 'PIN' : 'UNPIN',
        });
        if (res && res.status === false) {
          throw new Error(res.message || 'Error');
        }

        // Keep chatGroups in sync so list UI matches immediately.
        const chatGroups = this.$store.state.chat.chatGroups || [];
        const updated = Array.isArray(chatGroups) ? chatGroups.map((g) => {
          if (String(g.id) !== String(groupId)) return g;
          return {
            ...g,
            pin_at: next ? (new Date()).toISOString() : null,
          };
        }) : chatGroups;
        this.$store.commit('chat/updateChatGroups', updated);
        this.$store.dispatch("alerts/success", next ? 'Đã ghim hội thoại' : 'Đã bỏ ghim hội thoại');
      } catch (e) {
        this.conversationPinned = prev;
        this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra! Vui lòng thử lại');
      }
    },
    openAddMember() {
      this.$modal.show('add-user-modal', {
        type: TYPE_ADD_GROUP_MEMBER.UPDATE_GROUP,
        group_id: this.$route.params.messenger_id,
      });
    },
    leaveGroupChat(){
      if (this.isLastGroupAdmin) {
        this.$modal.show('dialog', {
          title: '',
          text: '<div class="leave-group-modal">Bạn là quản trị viên cuối của nhóm. Hãy chỉ định quản trị viên khác trước khi rời nhóm.</div>',
          buttons: [
            {
              title: 'Đóng',
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
        return;
      }
      this.$modal.show('dialog', {
        title: '',
        text: '<div class="leave-group-modal">Bạn có chắc muốn rời nhóm!</div>',
        buttons: [
          {
            title: 'Có',
            handler: () => {
              ChatService.leaveGroupChat({group_id : this.$route.params.messenger_id}).then(res => {
                if (res && res.status) {
                  // this.$store.dispatch("alerts/success", 'Bạn đã rời khỏi nhóm');
                  this.$router.push('/');
                }else{
                  this.$store.dispatch("alerts/error", (res && res.message) || 'Đã có lỗi xảy ra!');
                }
              });
              // this.$modal.hide('dialog')
            }
          },
          {
            title: 'Không',
            handler: () => {
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    dissolveGroupChat() {
      if (!this.isAdmin || !this.isGroup || this.isOfficialTeamGroupChat) {
        return;
      }

      this.$modal.show('dialog', {
        title: '',
        text: '<div class="leave-group-modal">Giải tán nhóm sẽ xóa cuộc trò chuyện này với <strong>tất cả</strong> thành viên. Hành động không thể hoàn tác. Bạn có chắc chắn?</div>',
        buttons: [
          {
            title: 'Giải tán',
            handler: () => {
              ChatService.dissolveGroupChat({ group_id: this.$route.params.messenger_id }).then(res => {
                if (res.status) {
                  this.$store.dispatch('chat/getChatGroups');
                  this.$router.push('/');
                } else {
                  this.$store.dispatch('alerts/error', res.message || 'Đã có lỗi xảy ra!');
                }
              });
            },
          },
          {
            title: 'Hủy',
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
        ],
      });
    },
    handleGroupName(){
      if(this.$store.state.chat.chatGroupSelected.type === 'GROUP'){
        if (this.isOfficialTeamGroupChat) {
          return;
        }
        this.handleName = !this.handleName;
        this.updateGroupName.name = this.$store.state.chat.chatGroupSelected.name;
      }else{
        this.goToProfile();
      }
    },


    applyChangeGroupName(){
      if(this.updateGroupName.name !== ''){
        ChatService.updateNameGroupChat(this.updateGroupName).then(res => {
          if (res.status) {

            let chatGroups = this.$store.state.chat.chatGroups;
            chatGroups.map((item) => {
                  if (item.id == this.$route.params.messenger_id) {
                    item.name = this.updateGroupName.name
                  }
                }
            )

            this.$store.commit('chat/updateChatGroups', chatGroups);

            this.$emit('update-name-group-chat', this.updateGroupName.name)
            this.handleGroupName();
            this.$store.dispatch("alerts/success", 'Cập nhật tên nhóm thành công');
          }else{
            this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra!');
          }
        });
      }
    },
    async copyGroupShareLink() {
      const text = String(this.groupShareLink || "").trim();
      if (!text) return;

      let copied = false;
      try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
          await navigator.clipboard.writeText(text);
          copied = true;
        }
      } catch (e) {
        void e;
      }

      if (!copied) {
        try {
          const ta = document.createElement("textarea");
          ta.value = text;
          ta.setAttribute("readonly", "");
          ta.style.position = "fixed";
          ta.style.left = "-9999px";
          document.body.appendChild(ta);
          ta.select();
          copied = document.execCommand("copy");
          document.body.removeChild(ta);
        } catch (e) {
          void e;
        }
      }

      if (copied) {
        this.showGroupLinkCopiedTip();
      }
    },

    showGroupLinkCopiedTip() {
      this.showGroupLinkCopied = true;
      if (this.groupLinkCopyHideTimer) {
        clearTimeout(this.groupLinkCopyHideTimer);
      }
      this.groupLinkCopyHideTimer = setTimeout(() => {
        this.hideGroupLinkCopiedTip();
      }, 2000);
    },

    hideGroupLinkCopiedTip() {
      this.showGroupLinkCopied = false;
      if (this.groupLinkCopyHideTimer) {
        clearTimeout(this.groupLinkCopyHideTimer);
        this.groupLinkCopyHideTimer = null;
      }
    },
    changeAvatar(){
      document.getElementById("update-avatar-btn").click();
    },
    async uploadFile(e) {
      const formFile = new FormData();

      formFile.append("files[]", e.target.files[0]);
      //
      await PostService.uploadFile(formFile).then(res => {
        if (res.status) {
          this.changeAvatarGroup(res['data'][0]);
        }else{
          this.$store.dispatch("alerts/error", 'Thay ảnh thất bại.');
        }
      });
    },
    async changeAvatarGroup(file){
      let data = {
        group_id: this.$route.params.messenger_id,
        file_id: file.file_id,
        avatar: file.url
      }

      ChatService.updateAvatarGroup(data).then(res => {
        if (res && res.status && res.data) {
          this.avatars = res.data.avatar ?? '/img/profile/avatar.png';
          this.$store.commit('chat/updateChatGroupSelected', res.data);
          this.$store.dispatch("alerts/success", 'Thay đổi ảnh nhóm thành công');
          this.$store.dispatch("chat/getChatGroups");
        } else {
          this.$store.dispatch("alerts/error", 'Thay ảnh thất bại.');
        }
      });
      const input = this.$refs.fileupload;
      input.type = 'text';
      input.type = 'file';
    },

    goToProfile(){
      window.open('/profile/' + this.$store.state.chat.chatGroupSelected.user_id, '_blank');
    },

    async notificationChange(){
      if (this.$store.state.chat.chatGroupSelected.type === 'BOT') {
        this.notificationIsActive = true;
        return;
      }
      let params = {
        group_id : this.$store.state.chat.chatGroupSelected.id,
        stage : this.notificationIsActive ? 'ON' : 'OFF'
      };

      await ChatService.notificationConvensation(params).then(res => {
        if(res.status){
          // let item = this.$store.state.chat.chatGroupSelected;
          // item.noty = res.data.stage;
          // this.$store.commit("chat/getChatGroups");
          // this.$store.commit("chat/updateChatGroupSelected", item);
          let chatGroups = this.$store.state.chat.chatGroups;
            chatGroups.map((item) => {
                  if (item.id == this.$route.params.messenger_id) {
                    item.noty = res.data.stage
                  }
                }
            )

            this.$store.commit('chat/updateChatGroups', chatGroups);
        }else{
          this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra! Vui lòng thử lại');

          //reset to old state
          this.notificationIsActive = this.notificationIsActive;
        }
      })
    },

    async updateRoleMember() {
      if (this.join_policy == 0) return;

      const joinPolicy = Number(this.join_policy) === 2 ? 2 : 1;
      try {
        const res = await GroupService.updateRoleMemberGroup(
          this.$route.params.messenger_id,
          { join_policy: joinPolicy },
        );
        if (!res || !res.status) {
          this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra!');
          return;
        }

        this.$store.dispatch("alerts/success", 'Đã thay đổi quyền thêm thành viên');

        const currentId = String(this.$route.params.messenger_id);
        const selected = this.$store.state.chat.chatGroupSelected || {};
        const patched = withJoinPolicy(selected, joinPolicy);
        this.$store.commit('chat/updateChatGroupSelected', patched);

        const chatGroups = (this.$store.state.chat.chatGroups || []).map((g) => (
          String(g.id) === currentId ? withJoinPolicy(g, joinPolicy) : g
        ));
        this.$store.commit('chat/updateChatGroups', chatGroups);

        await this.$store.dispatch('chat/getChatGroups');
        const refreshed = (this.$store.state.chat.chatGroups || []).find(
          (g) => String(g.id) === currentId,
        );
        if (refreshed) {
          this.$store.commit('chat/updateChatGroupSelected', refreshed);
          this.join_policy = Number(refreshed.settings?.join_policy) === 2 ? 2 : 1;
        }
      } catch {
        this.$store.dispatch("alerts/error", 'Đã có lỗi xảy ra!');
      }
    },

    updateAnnouncementPolicySetting() {
      const policy = parseInt(String(this.announcement_policy), 10);
      if (policy !== 1 && policy !== 2) return;

      GroupService.updateAnnouncementPolicy(this.$route.params.messenger_id, { announcement_policy: policy }).then((res) => {
        if (res.status) {
          this.$store.dispatch('alerts/success', 'Đã cập nhật quyền gửi thông báo');
          this.$store.dispatch('chat/getChatGroups');
        } else {
          this.$store.dispatch('alerts/error', 'Đã có lỗi xảy ra!');
        }
      });
    },

    /**
     * Đổi retention auto-delete tin nhắn cho hội thoại hiện tại.
     * Chỉ accept 5 giá trị whitelisted. Server đảm bảo authz cuối cùng.
     */
    async updateRetentionSetting() {
      if (this.isUserChat) {
        return;
      }
      if (this.retentionSaving) return;
      const days = Number(this.messageRetentionDays);
      if (!this.retentionOptions.includes(days)) {
        this.$store.dispatch('alerts/error', 'Giá trị không hợp lệ.');
        return;
      }
      const groupId = this.$route.params.messenger_id;
      if (!groupId) return;

      this.retentionSaving = true;
      try {
        const res = await GroupService.updateChatRetention(groupId, { message_retention_days: days });
        if (res && res.status) {
          this.$store.dispatch('alerts/success', 'Đã cập nhật thời gian giữ tin nhắn');
          // Refresh group list để mọi nơi (sidebar/header) thấy số ngày mới.
          this.$store.dispatch('chat/getChatGroups');
        } else {
          this.$store.dispatch('alerts/error', (res && res.message) || 'Không thể cập nhật.');
          // Rollback hiển thị về giá trị cũ trên store.
          const selected = this.$store.state.chat.chatGroupSelected || {};
          const cur = Number(selected.settings?.message_retention_days);
          this.messageRetentionDays = this.retentionOptions.includes(cur) ? cur : 30;
        }
      } catch (e) {
        this.$store.dispatch('alerts/error', 'Không thể cập nhật.');
      } finally {
        this.retentionSaving = false;
      }
    },
  }
}
</script>

<style lang="scss">
.leave-group-modal{
  text-align: center;
  padding: 10px;
  font-size: 15px;
}
.retention-readonly-value {
  margin-top: 4px;
  padding: 8px 0;
}

.setting-item{
  .select-box-role{
    border: 1px solid #dbdbdb;
    padding: 5px 0;
    border-radius: 4px;
    &:hover{
      cursor: pointer;
    }
  }
}

.sidebar-infomation{
    .sidebar-detail {
        width: 320px;
        .not-found-data {
            font-weight: 500;
            font-size: 13px;
        }
    }
    .custom-media-preview {
        padding: 12px 4px;
        border-bottom: 1px solid #dedfe2;
        overflow-x: hidden;
        max-width: 100%;
        &__header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            margin-bottom: 10px;
        }
        &__title {
            font-weight: 500;
            color: #18202a;
        }
        &__view-all {
            border: none;
            background: transparent;
            padding: 0;
            color: #2563eb;
            cursor: pointer;
        }
        &__loading,
        &__empty {
            font-size: 13px;
            color: #596073;
            padding: 4px 0;
        }
        &__grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-auto-rows: auto;
            gap: 8px;
            transition: opacity 0.15s ease;
        }
        &__grid--refreshing {
            opacity: 0.55;
            pointer-events: none;
        }
        &__cell {
            padding: 0;
            background: transparent;
            position: relative;
            border-radius: 8px;
            overflow: hidden;
            cursor: pointer;
            aspect-ratio: 1 / 1;
            border: 1px solid #e3e3e3;
        }
        &__thumb {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            background: #f1f5f9;
        }
        &__thumb--video {
            filter: brightness(0.85);
        }
        &__thumb--video-fallback {
            background: linear-gradient(145deg, #334155, #1e293b);
        }
        &__video-overlay {
            position: absolute;
            inset: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(0,0,0,0.18);
        }
        &__video-icon {
            width: 34px;
            height: 34px;
            border-radius: 999px;
            background: rgba(255,255,255,0.92);
            color: #111827;
            font-size: 24px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }
    }
    //custom
    .on-off-infomation {
        text-align: end;
        padding: 12px 12px 12px 16px;
    }
    .avatar-group-member{
        display: flex;
        justify-content: center;
        position: relative;
        width: 100%;
        .firstname-charset {
            align-items: center;
            color: #fff;
            display: flex;
            font-size: 20px;
            font-weight: 700;
            position: relative;

            .avatar-group-member__image,
            .image-template {
                width: 120px !important;
                height: 120px !important;
                border: 1px solid #d1d1d1;
            }

            img {
                width: 120px;
                height: 120px;
                border-radius: 100%;
                border: 1px solid #d1d1d1;
                object-fit: cover;
            }
            i {
                position: absolute;
                bottom: 0px;
                right: 0px;
                color: #000000d1;
            }
        }
    }
    .name-group {
        text-align: center;
        padding: 10px 0;
        display: inline-block;
        line-height: inherit;
        white-space: pre-line;
        width: 100%;
        word-break: break-word;
        .handle-button-group-name{
            text-align: right;
            margin-top: 10px;
            .button-change-name {
                padding: 5px 11px;
                font-weight: 600;
                font-size: 14px;
                background: var(--app-color-sliver);
                border-radius: 5px;
                margin-left: 10px;
            }
        }
        .change-group-name {
            align-items: center;
            border: 1px solid var(--app-color-sliver);
            border-radius: 4px;
            color: #000;
            display: flex;
            font-size: 16px;
            height: auto;
            line-height: inherit;
            margin-top: 16px;
            padding: 6px 0;
            position: relative;
            width: 100%;
        }
        .name-group-name-row {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            flex-wrap: wrap;
            max-width: 100%;
        }
        .official-team-verified {
            font-size: 18px !important;
            width: 18px;
            min-width: 18px;
            height: 18px;
            color: #16a34a !important;
            flex-shrink: 0;
        }

        .chat-leadership-badge {
            font-size: 18px !important;
            width: 18px;
            min-width: 18px;
            height: 18px;
            color: #f97316 !important;
            flex-shrink: 0;
        }
    }
      .custom-action-row {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 12px 6px;
        width: 100%;
      }
      .custom-action-row__item {
          border: none;
          background: transparent;
        border-radius: 10px;
        padding: 10px 2px;
        width: 64px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        cursor: pointer;
        min-height: 64px;
      }
      .custom-action-row__item:hover:not(:disabled) {
        background: #f7f7f8;
      }
      .custom-action-row__item--disabled,
      .custom-action-row__item:disabled {
        cursor: not-allowed;
        opacity: 0.55;
      }
      .custom-action-row__icon {
        font-size: 24px !important;
      }
      .custom-action-row__icon--active {
        color: #2563eb !important;
      }
      .custom-action-row__text {
        font-size: 12px;
        font-weight: 500;
        color: #18202a;
        line-height: 1.2;
        text-align: center;
        white-space: nowrap;
      }

      .custom-rule-block {
        .custom-rule-block__actions {
          display: inline-flex;
          align-items: center;
          gap: 2px;
          flex-shrink: 0;
        }
        .custom-rule-block__icon-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          padding: 0;
          border: none;
          border-radius: 8px;
          background: transparent;
          cursor: pointer;
          color: #18202a;
          &:hover {
            background: rgba(0, 0, 0, 0.06);
          }
          .md-icon {
            margin: 0;
            font-size: 22px !important;
          }
        }
        /* Giống bài viết: dùng global .post-layout + .text-html (TextContent.vue) */
        .custom-rule-block__body-shell.post-layout {
          max-width: none;
          margin: 0;
          width: 100%;
        }
        .custom-rule-block__preview {
          position: relative;
        }
        .custom-rule-block__text-html.text-html {
          padding: 0 8px;
        }
        .custom-rule-block__text-html--clamped {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 10;
          line-clamp: 10;
          overflow: hidden;
          word-break: break-word;
        }
        .custom-rule-block__see-more {
          display: block;
          width: 100%;
          margin: 4px 0 0;
          padding: 0 8px 4px;
          border: none;
          background: transparent;
          text-align: left;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: #0d47a1;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        .update-rule-group{
          .handle-button-group-name{
            margin-top: 10px;
            float: right;
            grid-gap: 10px;
            display: flex;
          }
          .button-rule{
            border: 1px solid #dbdbdb;
            padding: 5px 10px;
            border-radius: 4px;
          }
        }
      }
    .add-description{
        align-items: center;
        background-color: initial;
        border: none;
        border-radius: 0!important;
        box-shadow: none!important;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 16px 4px 12px;
        position: relative;
    }
    .head-custom {
        border-bottom: 1px solid #dedfe2;
        padding: 10px 0;
    }
    .cancel-or-submit {
        /* display: flex; */
        /* justify-content: space-between; */
        width: 80%;
        margin: auto;
        display: grid;
        grid-template-columns: 50% 20% 20%;
        align-items: center;
        padding: 10px 0;
        grid-gap: 10px;
        .button-cancel, .button-submit {
            padding: 5px 15px;
            font-size: 12px;
        }
    }
    .change-descript-group {
        cursor: pointer;
        display: block;
        font-size: 14px;
        line-height: 20px;
        outline: none;
        position: relative;
        resize: none;
        text-align: center;
        width: 80%;
        margin: auto;
        height: 20px;
        border-radius: 4px;
        box-sizing: content-box;
    }
    .info-thread__setting {
        display: flex;
        flex-direction: column;
        padding: 10px 0;
        .separator {
            margin: 4px 8px 4px 40px;
            background: #dddada;
            height: 1px;
            width: auto;
        }
        .setting-item.enable-click {
            cursor: pointer;
        }
        .setting-item {
            --spectrum-switch-cursor-hit-x: 0;
            align-items: center;
            display: flex;
            min-height: 44px;
            padding: 4px 8px;
            transition: all .35ms ease-out;
            grid-gap: 5px;
        }
        .setting-item--share-link {
            overflow: visible;
            position: relative;
            z-index: 2;
        }
        .setting-item.select {
            align-items: flex-start;
            select {
                width: 100%;
                margin-top: 8px;
                padding: 6px 6px;
            }
        }
        .setting-item__icon {
            margin-right: 8px;
        }
        .setting-item__content__title {
            display: flex;
            font-size: 14px;
        }
        .setting-item__content__subtitle {
            font-size: 14px;
            color: blue;
            word-break: break-word;
        }
        .setting-item__content {
            display: flex;
            flex: 1 1;
            flex-direction: column;
            overflow: hidden;
        }
        .leave-group{
            fill: var(--app-color-red);
        }
        .title-negative {
            color: var(--app-color-red);
        }
        svg path{
            fill: inherit;
        }
    }

    .group-danger-actions {
        margin-top: 10px;
        padding: 0 8px 8px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        &__btn {
            width: 100%;
            border: none;
            border-radius: 8px;
            background: #fdeaea;
            color: var(--app-color-red, #f5222d);
            padding: 10px 14px;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.35;
            cursor: pointer;
            text-align: center;
            transition: background 0.15s ease;

            &:hover {
                background: #fbd5d5;
            }

            &:active {
                background: #f8c4c4;
            }
        }

        &__btn--dissolve {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
        }

        &__label {
            font-weight: 500;
        }

        &__hint {
            font-size: 12px;
            font-weight: 400;
            color: #a94442;
            line-height: 1.3;
        }
    }
    //end custom
    //search
    .container-search-chat{
        margin: 12px 0px;
        //border-bottom: 1px solid var(--app-color-sliver);
        //padding-bottom: 10px;
        .container-input-search{
            display: flex;
            -webkit-box-flex: 1;
            flex-grow: 1;
            border: none;
            -webkit-box-align: center;
            align-items: center;
            padding: 8px;
            background: rgb(241, 242, 244);
            border-radius: 8px;
            margin-bottom: 20px;
            .input-search{
                display: flex;
                -webkit-box-flex: 1;
                flex-grow: 1;
                border: none;
                background: rgb(241, 242, 244);
                padding: 2px 0px;
                margin-left: 10px;
                outline: none;
                font-style: normal;
                font-weight: normal;
                font-size: 15px;
                line-height: 20px;
                text-decoration: none;
                color: rgb(38, 40, 44);
            }
        }
        .search_keyword {
            margin-top: 10px;
            margin-bottom: 10px;
            height: calc(100vh - 250px);
            overflow-y: auto;
        }
        .search_lists{
            padding: 6px 10px;
            border-radius: 8px;
            grid-gap: 10px;
            &:hover{
                background: #F6F7F7;
                cursor: pointer;
            }
            .search-avatar{
                .avatar{
                    border-radius: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
        }
    }
    //  membergroup
    .container-member-group{
        .list-action-infomation{
            width: max-content;
        }
        .add-member-button{
            color: #000000;
            height: 44px!important;
            justify-content: flex-start;
            margin: 8px;
            border: none;
            background: #fff;
        }
        .add-member-button__icon {
            background-color: #56ca7629;
            border-radius: 50%;
            margin-right: 12px;
            padding: 6px;
            font-weight: normal;
        }
        .list-members{
            .scroll-listmember{
                height: calc(100vh - 252px);
                overflow-y: auto;
            }
            .member-action-list{
                position: relative;
                .member-name{
                    font-size: 16px;
                    font-weight: 600;
                    word-break: break-word;
                    display: block;
                    width: 100%;
                    white-space: nowrap;
                }
                .department-member{
                    font-size: 12px;
                }
                .md-ripple {
                    padding: 4px;
                }
                .contact-action-member {
                    position: absolute;
                    right: 12px;
                    top: 28px;
                    border: 1px solid #dfdfdf45;
                    border-radius: 5px;
                    z-index: 10;
                    background: #fff;
                    font-size: 14px;
                    box-shadow: rgb(0 0 0 / 35%) 0px 5px 15px;
                }
                .action{
                    padding: 6px 12px;
                    &:hover{
                        background: var(--app-color-sliver);
                        cursor: pointer;
                    }
                }
            }
        }
        .detail-button-wrapper {
            button {
                width: 47%;
                cursor: pointer;
                padding: 4px 0;
            }
            button:hover {
                border: #00c853 1px solid;
            }
        }
    }
}

.custom-bot-announcement-action {
  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 12px 16px;
    border: none;
    border-radius: 10px;
    background: #fff3e0;
    color: #e65100;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
      background: #ffe0b2;
    }
  }

  &__icon {
    margin: 0;
    color: #e65100 !important;
  }
}

/* Modal gắn ra ngoài sidebar — không nằm trong .sidebar-infomation */
.custom-rule-full-modal {
  .custom-rule-full-modal__scroll {
    max-height: min(72vh, 640px);
    overflow-y: auto;
    padding: 8px 0 16px;
  }
  .custom-rule-block__body-shell.post-layout {
    max-width: none;
    margin: 0;
    width: 100%;
  }
  .text-html {
    padding: 0 12px;
  }
}

.group-link-copy-wrap {
  position: relative;
  flex-shrink: 0;
  overflow: visible;

  .group-link-copy-btn {
    width: 16px;
    height: 16px;
    cursor: pointer;
    display: block;
  }

  .group-link-copied-tip {
    position: absolute;
    right: 0;
    top: calc(100% + 8px);
    padding: 5px 10px;
    background: #1f2937;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
    white-space: nowrap;
    border-radius: 6px;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.22);
    z-index: 30;
    pointer-events: none;

    &::after {
      content: "";
      position: absolute;
      bottom: 100%;
      right: 10px;
      border: 5px solid transparent;
      border-bottom-color: #1f2937;
    }
  }
}

.group-link-copied-fade-enter-active,
.group-link-copied-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.group-link-copied-fade-enter,
.group-link-copied-fade-leave-to {
  opacity: 0;
  transform: translateY(4px);
}
</style>
